import {Injectable} from '@angular/core';

export const APPLICATION_CONFIGURATION = 'applicationConfig';

@Injectable()
export class ApplicationConfiguration {
    cdnPath = 'https://cdn.tiberhealth.com/';
    localUseCdn = true;
}
